<div class="row">
  <div class="col-12 col-md order-1">
    <h1>
      <slot name="title" />
    </h1>
  </div>
  <div
    class="col-12 col-md-auto text-center order-0 order-md-2 justify-content-end"
  >
    <slot name="breadcrumb" />
  </div>
  <div class="col-12 order-3">
    <p class="fs-6">
      <slot name="tagline" />
    </p>
    <slot name="extra" />
  </div>
</div>
